import {
  ClosedSidebarMenu,
  ClosedSidebarMenuItem,
  Menu,
  MenuItem,
} from "@wayfarer/components";
import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Sidebar.scss";
import { PageType } from "./config/SidebarPages";

export interface SidebarNavigation {
  pages: PageType[];
  mini?: boolean;
}

export const Sidebar = ({ pages, mini }: SidebarNavigation) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const selectedIndex = useMemo(() => {
    const idx = pages.findIndex(p => p.navigationLocation === pathname);
    return idx >= 0 ? idx : 0;
  }, [pages, pathname]);

  return mini ? (
    <ClosedSidebarMenu className="sidebar-mini" selectedIndex={selectedIndex}>
      {pages.map(page => (
        <ClosedSidebarMenuItem
          key={page.navigationLocation}
          className="medium-text"
          icon={() => page.icon()}
          onClick={() => navigate(page.navigationLocation)}
          aria-label={page.label}
        />
      ))}
    </ClosedSidebarMenu>
  ) : (
    <Menu className="sidebar" selectedIndex={[selectedIndex]}>
      {pages.map(page => (
        <MenuItem
          key={page.navigationLocation}
          className="medium-text"
          icon={() => page.icon()}
          label={page.label}
          onClick={() => navigate(page.navigationLocation)}
        />
      ))}
    </Menu>
  );
};
